module.exports = __webpack_public_path__ + "img/amaechi.f9f601d0.png";